import moment from 'moment';
import { closePopups } from "../../../init";

const iframe = <HTMLIFrameElement>document.getElementById('iframe-id-preview');
const idNumberSpan = <HTMLSpanElement>document.getElementById('idNumber')!;
const idExpirationDateSpan = <HTMLSpanElement>document.getElementById('idExpirationDate')!;
const bsnSpan = <HTMLSpanElement>document.getElementById('bsn')!;
const dobSpan = <HTMLSpanElement>document.getElementById('dob')!;
const btnClose = <HTMLButtonElement>document.getElementById('closePopup');

class IdentificationViewer {
    static openIFrame(id: string, idNumber?: string, idExpirationDate?: any, bsn?: string, dob?: string) {
        iframe.src = `/Admin/EmployeesRegistrationStatus/IdFile/${id}`;
        idNumberSpan.innerText = `${idNumber}`;
        idExpirationDateSpan.innerText = moment(idExpirationDate).format('DD-MM-YYYY');
        bsnSpan.innerText = `${bsn}`;
        dobSpan.innerText = dob ? moment(dob).format('DD-MM-YYYY') : 'onbekend';

        const target = document.getElementById('id-preview');
        if (target) {
            document.documentElement.classList.add('popup_open');
            target.classList.add('open');   
            document.documentElement.querySelector('.backface')!.classList.add('open');
        }
    };
}

if (btnClose) {
    btnClose.addEventListener('click', () => closePopups());
}

if (iframe) {
    iframe.addEventListener('load', () => {
        const ele = iframe.contentWindow!.document.getElementsByTagName('img')[0];
        if (ele && ele.width && ele.width > 600) {
            ele.style.width = '100%';
            ele.style.height = 'auto';
        }
    });
}

export default IdentificationViewer;
